import { Button } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useViewShortfalls } from 'all-in-one-shared-api';

import { useKeycloakReady } from 'hooks';

import { ShortfallAlert } from './components';

export const ShortfallWarning = (): JSX.Element => {
  const { t } = useTranslation();
  const { token, tokenParsed } = useKeycloakReady();
  const { data } = useViewShortfalls({ authToken: token, memberType: tokenParsed?.memberType });

  if (data?.results.length)
    return (
      <ShortfallAlert
        message={<Trans i18nKey="claims.shortfall.warning.message" />}
        description={t('claims.shortfall.warning.description')}
        type="warning"
        showIcon
        action={
          // Note(Anson Kan): doesn't seem to have a why to style its wrapper to center the button
          <Link to="/claims/shortfall">
            <Button type="primary" color="var(--primary-color)" size="large">
              {t('claims.shortfall.warning.button')}
            </Button>
          </Link>
        }
      />
    );

  return <></>;
};
